import { IFsFileType } from "@/components/r3f-components/component-data-structure";
import { FsBaseFile } from "./base";

export class FsAudio extends FsBaseFile {
    type: IFsFileType.Audio = IFsFileType.Audio
    mp3Url: string

    private _mp3Blob: Blob | undefined

    constructor(fileId: string, name: string) {
        super(fileId, name)
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/aud.mp3`
        this.mp3Url = url.toString()
    }

    getMp3Url() {
        return this.mp3Url
    }

    async load() {
        if (typeof this._mp3Blob === 'undefined') {
            const response = await fetch(this.mp3Url)
            this._mp3Blob = await response.blob()
        }
        return this
    }
}
